import { useEffect, useState } from "react";
import { Database, CheckCircle2, Clock } from "lucide-react";
import { API } from "../../lib/api";
import axios from "axios";
import { SYNC } from "../../constants/testIds";

// Small developer/internal indicator confirming secure backend lead sync.
export function SyncStatus() {
	const [cfg, setCfg] = useState(null);

	useEffect(() => {
		axios.get(`${API}/config`).then((r) => setCfg(r.data)).catch(() => setCfg(null));
	}, []);

	const configured = cfg?.sheets_configured;

	return (
		<div
			data-testid={SYNC.status}
			className="inline-flex items-center gap-2 rounded-full border border-slate-700 bg-slate-900 px-3 py-1.5 text-xs text-slate-300"
			title="Leads are captured securely on the server and synced to Google Sheets."
		>
			<Database className="h-3.5 w-3.5 text-emerald-400" />
			{configured ? (
				<><CheckCircle2 className="h-3.5 w-3.5 text-emerald-400" /> Google Sheets sync active</>
			) : (
				<><Clock className="h-3.5 w-3.5 text-amber-400" /> Secure lead capture active (Sheets: dev mode)</>
			)}
		</div>
	);
}
